import React from "react";
import { formatDateToTimeStampte } from "../../helpers/function";
import TreatmentHistory from "./TreatmentHistory";
import { useTranslation } from "react-i18next";

const TreatmentButtonDetail = ({ claim }) => {
  const { t, ready, i18n } = useTranslation();
  const currentLang = i18n.language || "fr";

  const activeTreatment = claim?.active_treatment;
  const responsible_staff =
    activeTreatment?.type === "escalation"
      ? activeTreatment?.responsible_staff_at_escalation
      : activeTreatment?.responsible_staff;

  // Détecter si la réclamation est non fondée (via l'id du motif, l'objet motif ou la date de déclaration)
  const isUnfounded =
    !!activeTreatment?.declared_unfounded_at ||
    !!activeTreatment?.unfounded_reason_id ||
    !!activeTreatment?.unfoundedReason ||
    !!activeTreatment?.unfounded_reason;

 // Extraire le libellé traduit du motif de non-fondé
  const getUnfoundedReasonLabel = () => {
    const reasonObj = activeTreatment?.unfoundedReason || activeTreatment?.unfounded_reason;

    // Si la relation est bien chargée sous forme d'objet
    if (reasonObj && typeof reasonObj === "object") {
      const lib = reasonObj.libelle || reasonObj.name || reasonObj;
      if (typeof lib === "object" && lib !== null) {
        return lib[currentLang] || lib["fr"] || lib["en"] || "-";
      }
      if (typeof lib === "string") return lib;
    }

    // Si on n'a que l'UUID (relation non chargée par l'API)
    if (activeTreatment?.unfounded_reason_id) {
      return activeTreatment.unfounded_reason_id;
    }

    return "-";
  };

  const unfoundedComment =
    activeTreatment?.unfounded_comment || activeTreatment?.unfounded_reason || "-";

  return ready ? (
    <div className="kt-wizard-v2__content" data-ktwizard-type="step-content">
      <div className="kt-heading kt-heading--md">
        {t("Information sur le Traitement Effectué")}
      </div>
      <div className="kt-form__section kt-form__section--first">
        {!claim || !activeTreatment ? (
          <div className="kt-wizard-v2__review-item">
            <div className="kt-wizard-v2__review-title">
              <h5 style={{ color: "#48465b" }}>{t("Aucune information")}</h5>
            </div>
          </div>
        ) : null}

        <div className="kt-wizard-v2__review">
          {/* CHARGÉ DU TRAITEMENT */}
          {responsible_staff ? (
            <div className="kt-wizard-v2__review-item">
              <div className="kt-wizard-v2__review-title">
                <span style={{ color: "#48465b" }}>{t("Chargé du traitement")}</span>
              </div>
              <div className="kt-wizard-v2__review-content">
                <strong>{t("Nom")}:</strong>
                <span className="mx-2">
                  {`${responsible_staff?.identite?.firstname || ""} ${
                    responsible_staff?.identite?.lastname || ""
                  }`}
                </span>
                <br />
                <strong>{t("Unité")}:</strong>
                <span className="mx-2">
                  {responsible_staff?.unit?.name?.fr || "-"}
                </span>
              </div>
              {
                <div className="kt-wizard-v2__review-content">
                  <strong>{t("Nom")}:</strong>
                  <span className="mx-2">
                    {`${responsible_staff?.identite
                      ?.firstname +
                      " " +
                      responsible_staff?.identite
                        ?.lastname}`}
                  </span>
                  <br />
                  {<strong>{t("Unité:")}</strong>}
                  {
                    <span className="mx-2">
                      {
                        responsible_staff?.unit?.name
                          ?.fr
                      }
                    </span>
                  }
                </div>
              }
            </div>
          ) : null}

          {/* HISTORIQUE INTERMÉDIAIRE (TreatmentHistory) */}
          {activeTreatment &&
          (activeTreatment.declared_unfounded_at || activeTreatment.solved_at) ? (
            <div className="kt-wizard-v2__review-item">
              <TreatmentHistory
                treatments={activeTreatment.treatments}
                claim={claim}
              />
            </div>
          ) : null}

          {/* DÉTAIL DU TRAITEMENT FINAL (DÉCISION) */}
          {activeTreatment && activeTreatment.validated_at ? (
            <div className="kt-wizard-v2__review-item">
              <div className="kt-wizard-v2__review-title">
                <span style={{ color: "#48465b" }}>{t("Traitement")}</span>
              </div>

              {/* CAS : RÉCLAMATION NON FONDÉE */}
              {isUnfounded ? (
                <div className="kt-wizard-v2__review-content">
                  <strong>{t("Nom")}:</strong>
                  <span className="mx-2">
                    {activeTreatment.validated_by
                      ? `${activeTreatment.validated_by.identite?.firstname || ""} ${
                          activeTreatment.validated_by.identite?.lastname || ""
                        }`
                      : "-"}
                  </span>
                  <br />

                  <strong>{t("Décision")}:</strong>
                  <span className="mx-2 text-danger font-weight-bold">
                    {t("Non fondée")}
                  </span>
                  <br />

                  <strong>{t("Motif de non-fondé")}:</strong>
                  <span className="mx-2 text-danger">
                    {getUnfoundedReasonLabel()}
                  </span>
                  <br />

                  <strong>{t("Commentaire de non-fondé")}:</strong>
                  <span className="mx-2">{unfoundedComment}</span>
                  <br />

                  {activeTreatment.solution_communicated ? (
                    <>
                      <strong>{t("Solution communiquée au client")}:</strong>
                      <span className="mx-2">
                        {activeTreatment.solution_communicated}
                      </span>
                      <br />
                    </>
                  ) : null}

                  <strong>{t("Date de la décision")}:</strong>
                  <span className="mx-2">
                    {formatDateToTimeStampte(
                      activeTreatment.declared_unfounded_at || activeTreatment.validated_at
                    )}
                  </span>
                  <br />
                </div>
              ) : (
                /* CAS : RÉCLAMATION FONDÉE ET VALIDÉE */
                <div className="kt-wizard-v2__review-content">
                  <strong>{t("Nom")}:</strong>
                  <span className="mx-2">
                    {activeTreatment.validated_by
                      ? `${activeTreatment.validated_by.identite?.firstname || ""} ${
                          activeTreatment.validated_by.identite?.lastname || ""
                        }`
                      : "-"}
                  </span>
                  <br />

                  <strong>{t("Décision")}:</strong>
                  <span className="mx-2">
                    {activeTreatment.invalidated_reason
                      ? t("Invalide")
                      : t("Valide")}
                  </span>
                  <br />

                  {activeTreatment.invalidated_reason ? (
                    <>
                      <strong>{t("Raison de l'invalidation")}:</strong>
                      <span className="mx-2 text-danger">
                        {activeTreatment.invalidated_reason}
                      </span>
                      <br />
                      <strong>{t("Date de l'invalidation")}:</strong>
                      <span className="mx-2">
                        {formatDateToTimeStampte(activeTreatment.validated_at)}
                      </span>
                      <br />
                    </>
                  ) : (
                    <>
                      <strong>{t("Solution Communiquée au client")}:</strong>
                      <span className="mx-2">
                        {activeTreatment.solution_communicated || "-"}
                      </span>
                      <br />
                      <strong>{t("Date de la validation")}:</strong>
                      <span className="mx-2">
                        {formatDateToTimeStampte(activeTreatment.validated_at)}
                      </span>
                      <br />
                    </>
                  )}
                </div>
              )}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  ) : null;
};

export default TreatmentButtonDetail;